/* Approved podcast enhancement; all state stays in this section. */
(()=>{'use strict';const key=Symbol.for('kervyra.podcast.challenge.sv.v1');if(document[key]){document[key].init(document);return;}const instances=new Map();
function setup(root){if(instances.has(root))return;
'use strict';
(() => {
  const form = root.querySelector('#challenge');
  const $ = selector => root.querySelector(selector);
  let firstPick = null;
  let zoomOrigin = null;
  const label = value => value === 'none' ? 'Inget än' : value;
  form.addEventListener('submit', event => event.preventDefault());
  form.addEventListener('change', event => {
    if (event.target.name === 'first' && firstPick === null) {
      $('#first-status').textContent = `Ditt första val: ${label(event.target.value)}`;
      root.querySelectorAll('.choice').forEach(card => {
        card.querySelector('.choice-state').textContent = card.querySelector('input').checked ? 'Vald' : `Välj ${card.dataset.letter}`;
      });
    }
    if (event.target.name === 'final') updateResult();
    if (event.target.name === 'topic') $('#topic-status').textContent = `Nästa samtalsämne: ${event.target.value}. Valet stannar på den här sidan; ingenting skickas.`;
  });
  $('#change-note').addEventListener('input', updateResult);
  $('#reveal').addEventListener('click', () => {
    if (firstPick !== null) return;
    firstPick = form.querySelector('input[name="first"]:checked')?.value || 'none';
    if (!form.querySelector('input[name="first"]:checked')) form.querySelector('input[name="first"][value="none"]').checked = true;
    $('#first-field').disabled = true;
    $('#first-status').textContent = `Första valet sparat: ${label(firstPick)}`;
    root.querySelectorAll('.choice').forEach(card => {
      card.querySelector('.choice-state').textContent = card.dataset.letter === firstPick ? 'Ditt första val' : 'Första omgången är klar';
    });
    $('#reveal-reminder').textContent = `Ditt första val: ${label(firstPick)}. Titta på profilen och ytan innan du väljer igen.`;
    ['#reveal-section','#second-choice','#last-round'].forEach(id => $(id).hidden = false);
    setModel(firstPick === 'none' ? 'A' : firstPick);
    $('#reveal').setAttribute('aria-expanded','true');
    $('#reveal').textContent = 'Detaljerna visas';
    $('#reveal').disabled = true;
    $('#reveal-title').focus({preventScroll:true});
    $('#reveal-section').scrollIntoView({block:'start',behavior:reduced() ? 'instant' : 'smooth'});
  });
  function reduced(){return window.matchMedia('(prefers-reduced-motion: reduce)').matches;}
  function setModel(letter){
    root.querySelectorAll('[data-model]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.model === letter)));
    root.querySelectorAll('[data-panel]').forEach(panel => panel.classList.toggle('active', panel.dataset.panel === letter));
  }
  root.querySelectorAll('[data-model]').forEach(button => button.addEventListener('click',() => setModel(button.dataset.model)));
  function updateResult(){
    const final = form.querySelector('input[name="final"]:checked')?.value;
    if (!final || firstPick === null) {$('#result').hidden = true;return;}
    $('#result').hidden = false;
    $('#result-first').textContent = label(firstPick);
    $('#result-final').textContent = label(final);
    let text;
    if(final === 'none') text = firstPick === 'none' ? 'Du håller valet öppet. Detaljen du fortfarande vill se kan bli din nästa fråga.' : 'Du har lämnat ditt första val. Att vilja ha mer tid är också ett fullständigt svar.';
    else if(firstPick === 'none') text = `Efter en närmare titt har du hittat en riktning: ${final}.`;
    else if(firstPick === final) text = `Du höll fast vid ${final}. Vilken detalj fångade din uppmärksamhet?`;
    else text = `Du ändrade ditt val från ${firstPick} till ${final}. Vilken detalj avgjorde?`;
    $('#result-description').textContent = text;
    $('#result-reason').textContent = $('#change-note').value.trim();
    $('#copy-status').textContent = '';
  }
  $('#copy-picks').addEventListener('click',async()=>{
    const final = form.querySelector('input[name="final"]:checked')?.value;
    if(!final || firstPick === null) return;
    const reason=$('#change-note').value.trim();
    const text=`Jag började med ${label(firstPick)} och valde till slut ${label(final)}${reason ? `, och detaljen som ändrade eller bekräftade mitt val var ${reason}` : '.'}`;
    try{await navigator.clipboard.writeText(text);$('#copy-status').textContent='Kopierat. Dela bara om du vill.';}
    catch{ $('#copy-status').textContent='Det går inte att kopiera här. Dina val visas ovan.'; }
  });
  $('#reset').addEventListener('click',()=>{
    HTMLFormElement.prototype.reset.call(form);firstPick=null;$('#first-field').disabled=false;
    ['#reveal-section','#second-choice','#last-round','#result'].forEach(id => $(id).hidden=true);
    $('#reveal').disabled=false;$('#reveal').setAttribute('aria-expanded','false');
    $('#reveal').innerHTML='Visa detaljerna <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14m-5-5 5 5-5 5"/></svg>';
    $('#first-status').textContent='Ta den tid du behöver. Det finns inga poäng.';
    $('#topic-status').textContent='Dina val stannar på den här sidan. Ingenting skickas.';
    $('#copy-status').textContent='';
    root.querySelectorAll('.choice').forEach(card=>card.querySelector('.choice-state').textContent=`Välj ${card.dataset.letter}`);
    form.querySelector('input[name="first"]').focus({preventScroll:true});
    $('#first-choice').scrollIntoView({behavior:reduced() ? 'instant' : 'smooth'});
  });
  const dialog=$('#photo-dialog');
  root.querySelectorAll('.zoom-photo').forEach(button=>button.addEventListener('click',()=>{
    zoomOrigin=button;$('#enlarged-photo').src=button.dataset.photo;$('#enlarged-photo').alt=button.dataset.alt;$('#enlarged-caption').textContent=button.dataset.alt;
    dialog.showModal();
  }));
  dialog.addEventListener('close',()=>zoomOrigin?.focus({preventScroll:true}));
  dialog.addEventListener('click',event=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left || event.clientX>box.right || event.clientY<box.top || event.clientY>box.bottom)dialog.close();}});
  root.querySelectorAll('img').forEach(img=>img.addEventListener('error',()=>{
    const message=document.createElement('span');message.className='photo-gap';message.textContent='Fotografiet kunde inte läsas in. Ladda om sidan för att försöka igen.';img.replaceWith(message);
  }));
})();

'use strict';
(() => {
  const audio=root.querySelector('#episode-audio');
  if(!audio)return;
  const status=root.querySelector('#audio-status');
  const chapterButtons=[...root.querySelectorAll('[data-seek]')];
  const timeLabel=value=>{const seconds=Math.max(0,Math.floor(value||0));return `${Math.floor(seconds/60)}:${String(seconds%60).padStart(2,'0')}`;};
  function updateChapter(){
    const current=[...chapterButtons].reverse().find(button=>Number(button.dataset.seek)<=audio.currentTime+.05);
    chapterButtons.forEach(button=>{if(button===current)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');});
  }
  function seek(seconds,title){
    if(!Number.isFinite(audio.duration)) {status.textContent='Ljudet läses fortfarande in. Försök igen om en stund.';return;}
    audio.currentTime=Math.min(Math.max(0,seconds),audio.duration);
    if(audio.paused)status.textContent=title?`Redo vid ”${title}”. Tryck på spela för att lyssna.`:`Redo vid ${timeLabel(audio.currentTime)}. Tryck på spela för att lyssna.`;
    updateChapter();
  }
  audio.addEventListener('loadedmetadata',()=>{root.querySelector('#audio-duration').textContent=timeLabel(Math.round(audio.duration));updateChapter();});
  audio.addEventListener('timeupdate',updateChapter);
  audio.addEventListener('play',()=>status.textContent='Spelar upp. Pausa när du vill ha mer tid att välja.');
  audio.addEventListener('pause',()=>{if(!audio.ended)status.textContent=`Pausat vid ${timeLabel(audio.currentTime)}. Fortsätt när du är redo.`;});
  audio.addEventListener('waiting',()=>status.textContent='Läser in ljud…');
  audio.addEventListener('playing',()=>status.textContent='Spelar upp. Pausa när du vill ha mer tid att välja.');
  audio.addEventListener('ended',()=>status.textContent='Avsnittet är slut. Lyssna igen eller gå till ett annat kapitel.');
  audio.addEventListener('error',()=>status.textContent='Ljudet kunde inte läsas in. Ladda om sidan eller ladda ner MP3-filen nedan.');
  root.querySelector('#audio-back').addEventListener('click',()=>seek(audio.currentTime-15));
  root.querySelector('#audio-forward').addEventListener('click',()=>seek(audio.currentTime+15));
  root.querySelector('#audio-speed').addEventListener('change',event=>{audio.playbackRate=Number(event.target.value);status.textContent=`Uppspelningshastighet: ${event.target.selectedOptions[0].textContent}.`;});
  chapterButtons.forEach(button=>button.addEventListener('click',()=>seek(Number(button.dataset.seek),button.dataset.chapter)));
})();

instances.set(root,{destroy(){const a=root.querySelector('audio');if(a)a.pause();const d=root.querySelector('dialog');if(d&&d.open)d.close();instances.delete(root);}});}
function init(scope){if(scope.matches?.('[data-kv-podcast]'))setup(scope);scope.querySelectorAll('[data-kv-podcast]').forEach(setup);}
function unload(scope){for(const [root,instance]of instances){if(scope===root||scope.contains(root))instance.destroy();}}
Object.defineProperty(document,key,{value:{init,unload},configurable:true});document.addEventListener('shopify:section:load',e=>init(e.target));document.addEventListener('shopify:section:unload',e=>unload(e.target));if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);})();
